'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _assistant = require('../actions/assistant');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getAssistants),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(addAssistant),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(toggleAssistantState),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(assistant);

var assistants = function assistants(state) {
  return state.assistant;
};

function getAssistants(action) {
  var accountKey, assistantsHeaders, getAssistantsAPI, assistantsData, assistantsList;
  return _regenerator2.default.wrap(function getAssistants$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          accountKey = (0, _webUtils.decodeJwtToken)(_webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN)).payLoad.unique_name;
          assistantsHeaders = [{
            key: 'AccountKey',
            value: accountKey
          }];
          getAssistantsAPI = new _webUtils.API();
          _context.next = 5;
          return getAssistantsAPI.get('' + _webUtils.Urls.assistant.getAssistants + action.entityKey, assistantsHeaders);

        case 5:
          assistantsData = _context.sent;

          if (!_webUtils.STATUS.isSuccess(assistantsData.status)) {
            _context.next = 13;
            break;
          }

          assistantsList = new Map();

          assistantsData.data.map(function (assistantData) {
            assistantsList.set(assistantData.AccountKey, _extends({}, assistantData));
            return true;
          });
          _context.next = 11;
          return (0, _effects.put)({
            type: _assistant.ASSISTANT.FETCH_ASSISTANTS.SUCCESS,
            assistants: assistantsList
          });

        case 11:
          _context.next = 15;
          break;

        case 13:
          _context.next = 15;
          return (0, _effects.put)({
            type: _assistant.ASSISTANT.FETCH_ASSISTANTS.FAIL
          });

        case 15:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function addAssistant(action) {
  var accountToken, assistantsHeaders, addAssistantBody, addAssistantAPI, result;
  return _regenerator2.default.wrap(function addAssistant$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          assistantsHeaders = [{
            key: 'x-vzt-authentication',
            value: accountToken
          }];
          addAssistantBody = {
            EntityKey: action.entityKey,
            Assistant: action.assistantDetails
          };
          addAssistantAPI = new _webUtils.API();
          _context2.next = 6;
          return addAssistantAPI.post(_webUtils.Urls.assistant.addAssistant, addAssistantBody, assistantsHeaders, false);

        case 6:
          result = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(result.status)) {
            _context2.next = 12;
            break;
          }

          _context2.next = 10;
          return [(0, _effects.put)({
            type: _assistant.ASSISTANT.ADD_ASSISTANT.SUCCESS
          }), (0, _effects.put)({
            type: _assistant.ASSISTANT.FETCH_ASSISTANTS.LOAD,
            entityKey: action.entityKey
          })];

        case 10:
          _context2.next = 14;
          break;

        case 12:
          _context2.next = 14;
          return (0, _effects.put)({
            type: _assistant.ASSISTANT.ADD_ASSISTANT.FAIL,
            errorMessage: result.data
          });

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function toggleAssistantState(action) {
  var accountKey, assistantsHeaders, toggleAssistantStateAPI, result, assistantsState, assistantsList, selectedAssistant;
  return _regenerator2.default.wrap(function toggleAssistantState$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          accountKey = (0, _webUtils.decodeJwtToken)(_webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN)).payLoad.unique_name;
          assistantsHeaders = [{
            key: 'AccountKey',
            value: accountKey
          }];
          toggleAssistantStateAPI = new _webUtils.API();
          _context3.next = 5;
          return toggleAssistantStateAPI.post(_webUtils.Urls.assistant.toggleAssistantState, action.state, assistantsHeaders, false);

        case 5:
          result = _context3.sent;

          if (!_webUtils.STATUS.isSuccess(result.status)) {
            _context3.next = 18;
            break;
          }

          _context3.next = 9;
          return (0, _effects.select)(assistants);

        case 9:
          assistantsState = _context3.sent;
          assistantsList = assistantsState.getAssistants.assistantsList;
          selectedAssistant = assistantsList.get(action.state.AccountKey);

          selectedAssistant.IsActive = action.state.IsActive;
          assistantsList.set(action.state.AccountKey, selectedAssistant);
          _context3.next = 16;
          return [(0, _effects.put)({
            type: _assistant.ASSISTANT.FETCH_ASSISTANTS.SUCCESS,
            assistants: assistantsList
          }), (0, _effects.put)({
            type: _assistant.ASSISTANT.ASSISTANT_STATE.SUCCESS
          })];

        case 16:
          _context3.next = 20;
          break;

        case 18:
          _context3.next = 20;
          return (0, _effects.put)({
            type: _assistant.ASSISTANT.ASSISTANT_STATE.FAIL
          });

        case 20:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function assistant() {
  return _regenerator2.default.wrap(function assistant$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeEvery)(_assistant.ASSISTANT.FETCH_ASSISTANTS.LOAD, getAssistants);

        case 2:
          _context4.next = 4;
          return (0, _effects.takeEvery)(_assistant.ASSISTANT.ADD_ASSISTANT.LOAD, addAssistant);

        case 4:
          _context4.next = 6;
          return (0, _effects.takeLatest)(_assistant.ASSISTANT.ASSISTANT_STATE.LOAD, toggleAssistantState);

        case 6:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

exports.default = assistant;
module.exports = exports['default'];